import 'scss/services/VAT-invoice-recg.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { config } from 'config'

$(function () {
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).data('packageId')
    let params = {
      wareId: '1108',
      packageId: packageId,
      serviceName: '增值税发票识别 intsig',
      businessId: 'invoice'
    }
    goServiceBuy(params)
  })
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/VAT-invoice-recg.js